import ApiV2 from './api-v2';

interface QuoteDetectionResponse {
  stream_id: string;
  segments_processed: number;
  words_extracted: number;
  quotes_detected: number;
  fragments_created: number;
  quotes: { quote: string; start_time: number; end_time: number }[];
  timing_sec: { quote_detection: number };
}

/**
 * Triggers quote detection for a given stream via eos-app.
 * eos-app proxies to the transcript-to-clip-gen /quote-detection endpoint.
 * Creates topic fragments with "QUOTE: " prefix in fragment_name.
 */
export async function runQuoteDetection(streamId: string): Promise<QuoteDetectionResponse> {
  return ApiV2.post<QuoteDetectionResponse>(
    `/api/streams/${encodeURIComponent(streamId)}/quote-detection`,
  );
}
